<form class="mc-spring-board" (ngSubmit)="onSubmit()">
  <div class="mc-spring-board-form-body">
    <p class="mc-form-text">
      Delete <b>{{translationPackage?.Name}}?</b>
    </p>
    <p class="mc-form-text">
      Deleting a translation package will permanently remove it and all of the related language branches.
    </p>
    <p class="mc-form-title">
      Type "<b>{{translationPackage?.Name}}</b>" in the text box below to delete the translation package.
    </p>
    <mat-form-field class="mc-form-field" color="secondary">
      <input type="text" matInput name="confirm" #confirmInput placeholder="Confirm Delete">
    </mat-form-field>
  </div>

  <div class="mc-spring-board-form-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>

    <div class="mc-form-buttons">
      <button type="button" mat-stroked-button (click)="onCancelClicked()">Cancel</button>
      <button type="submit" mat-raised-button color="warn" [disabled]="confirmInput.value != translationPackage?.Name || (savingState.loading$ | async)">Delete</button>
    </div>
  </div>

  <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
</form>